import { Link } from "react-router-dom";
import Loading from "./Loading";
import { useAppDispatch } from "src/hooks/redux";
import { useEffect } from "react";
import { getItems } from "src/modules/spItems/actions";
import { systemsListName } from "src/api/config";
import { useGetSelect } from "src/hooks/redux-selectors";
import { modifiedSystemsList } from "src/modules/systems/selectors";

function SystemSide() {
  const dispatch = useAppDispatch();

  const { data, status } = useGetSelect(systemsListName);

  let systems = modifiedSystemsList(data);

  useEffect(() => {
    dispatch(
      getItems({
        listName: systemsListName,
        sortOrder: { name: "Sort_ID", asc: true },
      })
    );
  }, [dispatch]);

  if (status !== "SUCCESS") return <Loading />;

  return (
    <div className="flex flex-row flex-wrap gap-y-[10px] sm:gap-y-4 gap-x-7">
      {systems.map((item, index) => {
        if (index !== 1 && index !== 0) return null;

        const { id, url, title, description, externalLink } = item;

        const iconUrl = url;

        return (
          <Link
            to={externalLink || `/dashboard/${id}`}
            key={id}
            className="group cursor-pointer relative card flex-initial basis-[calc(50%-15px)] max-sm:basis-full flex"
          >
            <div className="flex flex-row w-full sm:h-[108px] max-sm:h-[64px] items-center justify-center">
              <div className="relative z-[5] flex flex-col items-start sm:items-center justify-center h-full p-5 transition-opacity duration-500 bg-white rounded-lg opacity-100 group-hover:z-0 sm:group-hover:opacity-0 grow shadow-custom">
                <div className="flex flex-row gap-2">
                  <div className="flex flex-col grow justify-center items-center">
                    <div className="w-6 h-6">
                      <img className="object-contain w-full h-full" src={iconUrl} alt={title} srcSet={iconUrl} />
                    </div>
                  </div>
                  <div className="flex flex-col justify-center items-center">
                    <h4>{title}</h4>
                  </div>
                </div>
              </div>
              <div className="absolute max-sm:hidden z-0 justify-center group-hover:z-10 top-0 bottom-0 h-[108px] max-sm:h-[100px] max-sm:mb-5 transition-opacity duration-500 opacity-0 sm:group-hover:opacity-100 left-0 right-0 flex flex-col px-5 py-4 bg-white rounded-lg shadow-custom">
                <div className="flex flex-row gap-5 items-center">
                  <div className="flex flex-col justify-center">
                    <div className="w-6 h-6">
                      <img className="object-contain w-full h-full" src={iconUrl} alt={title} srcSet={iconUrl} />
                    </div>
                  </div>
                  <div className="flex flex-col leading-4 text-[12px] line-clamp-5">
                    <p>{description}</p>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
}

export default SystemSide;
